import React from 'react'
import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'
import { map } from 'lodash'
import Button from '../../../../components/Button'

const Inner = styled.div`
  padding: 30px 35px 25px;
  max-width: 480px;
  font-family: Hind;
`
const Title = styled.div`
  font-size: 22px;
  color: #000;
  margin-bottom: 12px;
`
const Intro = styled.div`
  font-size: 15px;
  color: #444;
  margin-bottom: 12px;
`
const Item = styled.li`
  font-size: 15px;
  color: #000;
  line-height: 24px;
`
const Footer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

// STY-730 / spec R7: what's still needed before this can be submitted.
const MissingRequirementsDialog = ({ items, onClose }) => (
  <Dialog open={Boolean(items && items.length)} onClose={onClose}>
    <Inner>
      <Title>Almost there!</Title>
      <Intro>Before you can submit, please:</Intro>
      <ul>
        {map(items, (item) => <Item key={item.key}>{item.missing}</Item>)}
      </ul>
      <Footer>
        <Button text='Got it' onClick={onClose} />
      </Footer>
    </Inner>
  </Dialog>
)

export default MissingRequirementsDialog
